import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { ActivityPreviewEditorDialogService } from './activity-preview-editor-dialog.service';

export const ngxActivityPreviewEditorDialogServiceModule = angular.module('ngxActivityPreviewEditorDialogServiceModule', [])
	.factory('ngxActivityPreviewEditorDialogService', downgradeInjectable(ActivityPreviewEditorDialogService) as any)
	.name;

export * from './activity-editor-context';
export * from './activity-preview-editor-dialog.component';
export * from './activity-preview-editor-dialog.service';
export * from './activity-preview-editor-store';
export * from './activity-preview-task-policy.service';
